import React from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import * as RootActions from '../../../actions/index';
import * as CalendarActions from '../../../actions/calendar';
import { eventPresave, eventSaved } from '../../../actions/calendar';
import { saveEvent } from '../../../../api/emailsApi/calendar';
import '../Save.scss';
import calendarEventStatus from '../../../utils/calendarEventStatus';
import officeApi from '../../../../api/officeApi';

export const Save = () => {
  const dispatch = useDispatch();
  const isCalendarEventSaved = useSelector((state) => state.calendar.isCalendarEventSaved);
  const eventId = useSelector((state) => state.calendar.eventId);
  const salesforceEventId = useSelector((state) => state.calendar.salesforceEventId);
  const preSave = useSelector((state) => state.calendar.presave);
  const selectedRecord = useSelector((state) => state.calendar.selectedRecord);
  const organizer = useSelector((state) => state.calendar.selectedOrganizer);
  const isComposingEvent = useSelector((state) => state.calendar.isComposingEvent);
  const attendeeChange = useSelector((state) => state.calendar.attendeeChange);
  const multiMatchAttendeeFixed = useSelector((state) => state.calendar.multiMatchAttendeeFixed);
  const selectedContacts = useSelector((state) => state.calendar.selectedContacts);
  const isMissingContacts = useSelector((state) => state.calendar.isMissingContacts);
  const multipleMatchedOrganizers = useSelector((state) => state.calendar.multipleMatchedOrganizers);
  const multipleMatchedContacts = useSelector((state) => state.calendar.multipleMatchedContacts);
  const attendeeRecordRequired = useSelector((state) => state.mail.settings?.calendarSettings?.attendeeContactSettings?.attendeeRecordRequired);
  const start = useSelector((state) => state.calendar.eventStart);
  const subject = useSelector((state) => state.calendar.eventSubject);
  const isAllDay = useSelector((state) => state.calendar.eventAllDay);
  const eventStatus = useSelector((state) => state.calendar.eventStatus);
  const selectedRecordChange = useSelector((state) => state.calendar.selectedRecordChange);
  const userEmail = useSelector((state) => state?.auth?.user?.email);

  const enabled = (selectedRecordChange ||
                    (!isCalendarEventSaved && !preSave) ||
                    (isComposingEvent && attendeeChange) ||
                    (isCalendarEventSaved && attendeeChange)) &&
                    (multiMatchAttendeeFixed || !((calendarEventStatus.saved || calendarEventStatus.saving) && !isComposingEvent && isMissingContacts && attendeeChange)) &&
                  eventStatus !== calendarEventStatus.deleting &&
                  Object.keys(multipleMatchedOrganizers).length < 1;
  const handleSave = async () => {
    if (attendeeRecordRequired) {
      if (isMissingContacts) {
        dispatch(RootActions.changeAlertText('Create contact in Litify for all attendees to save.', 'error'));
        return;
      } else if (Object.keys(multipleMatchedContacts).length) {
        dispatch(RootActions.changeAlertText('Multiple matching attendees found. Select 1 to save.', 'error'));
        return;
      }
    }

    if (Object.keys(multipleMatchedOrganizers).length) {
      dispatch(RootActions.changeAlertText('Multiple matching organizers found. Select 1 to save.', 'error'));
      return;
    }

    dispatch(RootActions.isLoading(true));
    const isPresaving = isComposingEvent;
    const requestBody = {
      preSave: isPresaving,
      organizerId: organizer.objectId,
      organizerEmail: organizer.emailAddress,
      attendees: Object.values(selectedContacts).map((attendee) => ({
        email: attendee.emailAddress,
        id: attendee.objectId,
      })),
    };

    // if there's no ID, we need someway to identify this save
    if (!eventId) {
      requestBody.details = {
        start: isAllDay ? `${start.toISOString().split('T')[0]}T00:00:00.000Z` : start.toISOString(),
        subject,
      };
    }

    if (selectedRecord) {
      requestBody.relatedToApiName = selectedRecord.type;
      requestBody.relatedToId = selectedRecord.Id;
    }
    if (salesforceEventId) {
      requestBody.salesforceEventId = salesforceEventId;
    }
    try {
      const sharedProperties = await officeApi.getSharedProperties([]);
      let ownerEmail = sharedProperties?.owner;
      // if the owner is the current user, we don't need to pass the owner email
      if (ownerEmail === userEmail) {
        ownerEmail = null;
      }
      const savedEvent = await saveEvent(requestBody, eventId || 'undefined', ownerEmail);
      batch(() => {
        dispatch(CalendarActions.setSavedEventAttendees(savedEvent.data?.attendees));
        if (isPresaving) {
          dispatch(eventPresave());
          dispatch(RootActions.changeAlertText(`Calendar Event is ready to send.`));
        } else {
          dispatch(eventSaved());
          dispatch(RootActions.changeAlertText(`Calendar Event is saving.`));
        }
      });
    } catch (error) {
      console.error(error);
      if (error.response && error.response.status === 404) {
        dispatch(RootActions.changeAlertText(`Event not yet synced to server. Wait a few seconds and try again.`, 'error'));
      } else if (error.response && error.response.status === 400 && error?.response?.data?.calendarSyncDisabled) {
        dispatch(CalendarActions.syncDisabled(true));
      } else {
        dispatch(RootActions.changeAlertText(`Error saving Event. Please try again.`, 'error'));
      }
    }
    dispatch(RootActions.isLoading(false));
  };
  return (
    <div className='save-component'>
      <button className='save-button' onClick={handleSave} disabled={!enabled}>
                Save
      </button>
    </div>
  );
};
